import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { homePathForUser, AccessUnavailable, LOGIN_PATH, CHANGE_PASSWORD_PATH } from './RoleHomeRedirect';

/**
 * Role gate for the authenticated tree (spec: "Un usuario autenticado no
 * puede entrar al árbol del otro rol aunque escriba la URL manualmente").
 *
 * Order matters:
 * 1. No session at all -> back to login.
 * 2. A pending mandatory password change blocks every business route, even
 *    one this role would otherwise be allowed into (spec: "sólo se permite
 *    /cambiar-password y logout").
 * 3. The role matches -> render the guarded page.
 * 4. The role doesn't match -> send it to ITS OWN home, never the one it
 *    tried, so e.g. an admin can never render the member tree.
 * 5. A role with no home -> a clear "access unavailable" message instead
 *    of a redirect loop.
 */
export function RoleRoute({ roles, children }) {
  const { user } = useAuth();

  if (!user) return <Navigate to={LOGIN_PATH} replace />;
  if (user.mustChangePassword) return <Navigate to={CHANGE_PASSWORD_PATH} replace />;
  if (roles.includes(user.role)) return children;

  const ownHome = homePathForUser(user);
  if (!ownHome) return <AccessUnavailable />;
  return <Navigate to={ownHome} replace />;
}
